import dayjs, { Dayjs } from "dayjs";
import { numericFormatter } from "react-number-format";
import { isNullOrEmpty } from "./utils";

export function formatString(string?: any) {
    if (string === "" || string === null || string === undefined) return "---";
    return String(string);
}

export function formatDate(date?: string | Date | Dayjs, withTime: boolean = false) {
    if (!date) return "---";
    if (withTime) return dayjs(date).format("DD/MM/YYYY - HH:mm");
    else return dayjs(date).format("DD/MM/YYYY");
}

export function formatNumber(number?: number | string, decimalScale: number = 2) {
    if (isNullOrEmpty(number)) return "---";
    const epxonent = Math.pow(10, decimalScale);
    return numericFormatter(String(Math.round(Number(number) * epxonent) / epxonent), { thousandSeparator: ".", decimalSeparator: ",", decimalScale });
}